import { render } from "./SendMessagePage.vue?vue&type=template&id=4826d14a&ts=true"
import script from "./SendMessagePage.vue?vue&type=script&lang=ts"
export * from "./SendMessagePage.vue?vue&type=script&lang=ts"

import "./SendMessagePage.vue?vue&type=style&index=0&id=4826d14a&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/TTYT_NHS/ZaloOA/ZaloOA_TTYT_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__